import { AfterViewInit, ElementRef, } from "@angular/core";
var OnboardingPanelCardComponent = /** @class */ (function () {
    function OnboardingPanelCardComponent(hostRef) {
        this.hostRef = hostRef;
    }
    Object.defineProperty(OnboardingPanelCardComponent.prototype, "isCurrencyNumber", {
        get: function () {
            return (this.data &&
                this.data.price &&
                this.data.price.value &&
                /^-{0,1}\d*\.{0,1}\d+$/.test(this.data.price.value));
        },
        enumerable: true,
        configurable: true
    });
    OnboardingPanelCardComponent.prototype.ngAfterViewInit = function () {
        this.setCustomThemeProperties(this.data);
    };
    OnboardingPanelCardComponent.prototype.setCustomThemeProperties = function (d) {
        if (d.bodyColor && d.bodyColor.value) {
            this.hostRef.nativeElement.style.setProperty("--onboarding-card-body-color", d.bodyColor.value);
        }
        if (d.textColor && d.textColor.value) {
            this.hostRef.nativeElement.style.setProperty("--onboarding-card-text-color", d.textColor.value);
        }
        if (d.linkHexColor && d.linkHexColor.value) {
            this.hostRef.nativeElement.style.setProperty("--onboarding-card-link-color", d.linkHexColor.value);
        }
    };
    return OnboardingPanelCardComponent;
}());
export { OnboardingPanelCardComponent };
